import { authGet } from "@api";
import { DEPLOYMENT_URL } from "@constants";

interface DeploymentGithubAppStatusResponse {
  github_app_status: boolean;
}

export const fetchDeploymentGithubAppStatus = (
  deploymentId: string
): Promise<DeploymentGithubAppStatusResponse> => {
  return authGet<DeploymentGithubAppStatusResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/github_app_status`
  );
};
